import React, { useEffect, useState } from "react";
import { Table, Button, Modal, Form, Container, Row, Col, Card, Spinner, Badge } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { FaPlus, FaEdit, FaTrash, FaArrowLeft, FaSearch, FaUserTie } from "react-icons/fa";
import { useTipoOrigenTrabajadores } from '../../../services/hooks/useTipoOrigenTrabajadores';

const MantenimientoTiposOrigenTrabajadores = () => {
  const navigate = useNavigate();
  const selectedProject = JSON.parse(localStorage.getItem("selectedProject"));
  
  const { 
    tiposOrigen, 
    loading, 
    fetchTiposOrigen, 
    createTipoOrigen, 
    updateTipoOrigen, 
    deleteTipoOrigen 
  } = useTipoOrigenTrabajadores();
  
  const [showModal, setShowModal] = useState(false);
  const [editTipo, setEditTipo] = useState(null);
  const [formData, setFormData] = useState({ nombre: "" });
  const [searchTerm, setSearchTerm] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [tipoToDelete, setTipoToDelete] = useState(null);

  useEffect(() => {
    fetchTiposOrigen();
  }, [fetchTiposOrigen]);

  const handleOpenCreateModal = () => {
    setEditTipo(null);
    setFormData({ nombre: "" });
    setShowModal(true);
  };

  const handleOpenEditModal = (tipo) => {
    setEditTipo(tipo);
    setFormData({ nombre: tipo.nombre });
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditTipo(null);
    setFormData({ nombre: "" });
  };

  const handleSave = async () => {
    if (!formData.nombre.trim()) {
      toast.error("El nombre es obligatorio");
      return;
    }

    try {
      if (editTipo) {
        await updateTipoOrigen(editTipo.id, formData);
      } else {
        await createTipoOrigen(formData);
      }
      handleCloseModal();
      await fetchTiposOrigen();
    } catch (error) {
      console.error("Error al guardar:", error);
    }
  };

  const handleDelete = (tipo) => {
    setTipoToDelete(tipo);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    if (!tipoToDelete) return;
    
    try {
      await deleteTipoOrigen(tipoToDelete.id);
      setShowDeleteModal(false);
      setTipoToDelete(null);
      await fetchTiposOrigen();
    } catch (error) {
      console.error("Error al eliminar:", error);
    }
  };

  const filteredTipos = tiposOrigen.filter(tipo =>
    tipo.nombre?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      {/* Digital Harmony Styles */}
      <style>
        {`
          /* Fondo degradado */
          .dh-maintenance-bg {
            background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
            min-height: 100vh;
          }
          
          /* Header principal */
          .dh-main-header {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            padding: 2rem 0;
            margin-bottom: 2rem;
            border-radius: 0 0 30px 30px;
            box-shadow: 0 10px 30px rgba(102, 126, 234, 0.2);
          }
          
          .dh-main-title {
            font-size: 2.2rem;
            font-weight: 700;
            margin: 0;
          }
          
          .dh-main-subtitle {
            font-size: 1.1rem;
            opacity: 0.9;
            margin: 0.5rem 0 0 0;
          }
          
          /* Cards con Digital Harmony */
          .dh-card {
            border: none;
            border-radius: 20px;
            box-shadow: 0 15px 35px rgba(0,0,0,0.1);
            background: white;
            margin-bottom: 2rem;
          }
          
          .dh-card-header {
            border-radius: 20px 20px 0 0;
            padding: 1.5rem 2rem;
            border: none;
            font-weight: 700;
          }
          
          .dh-card-header-primary {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
          }
          
          /* Botones Digital Harmony */
          .btn-dh-primary {
            background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
            border: none;
            color: white;
            border-radius: 12px;
            padding: 12px 20px;
            font-weight: 600;
            box-shadow: 0 4px 14px rgba(17, 153, 142, 0.3);
            transition: all 0.3s ease;
          }
          
          .btn-dh-primary:hover {
            background: linear-gradient(135deg, #38ef7d 0%, #2dd4bf 100%);
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(17, 153, 142, 0.4);
            color: white;
          }
          
          .btn-dh-warning {
            background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);
            border: none;
            color: white;
            border-radius: 12px;
            padding: 8px 16px;
            font-weight: 600;
            box-shadow: 0 4px 14px rgba(251, 191, 36, 0.3);
            transition: all 0.3s ease;
          }
          
          .btn-dh-warning:hover {
            background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(251, 191, 36, 0.4);
            color: white;
          }
          
          .btn-dh-danger {
            background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
            border: none;
            color: white;
            border-radius: 12px;
            padding: 8px 16px;
            font-weight: 600;
            box-shadow: 0 4px 14px rgba(239, 68, 68, 0.3);
            transition: all 0.3s ease;
          }
          
          .btn-dh-danger:hover {
            background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(239, 68, 68, 0.4);
            color: white;
          }
          
          .btn-dh-secondary {
            background: linear-gradient(135deg, #6b7280 0%, #374151 100%);
            border: none;
            color: white;
            border-radius: 12px;
            padding: 12px 20px;
            font-weight: 600;
            box-shadow: 0 4px 14px rgba(107, 114, 128, 0.3);
            transition: all 0.3s ease;
          }
          
          .btn-dh-secondary:hover {
            background: linear-gradient(135deg, #374151 0%, #1f2937 100%);
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(107, 114, 128, 0.4);
            color: white;
          }
          
          /* Campos de formulario modernos */
          .dh-form-control {
            border: 2px solid #e5e7eb;
            border-radius: 10px;
            padding: 12px 16px;
            font-size: 1rem;
            transition: all 0.3s ease;
            background: rgba(255, 255, 255, 0.9);
          }
          
          .dh-form-control:focus {
            border-color: #667eea;
            box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25);
            background: white;
          }
          
          /* Enhanced Table */
          .dh-enhanced-table {
            border-collapse: separate;
            border-spacing: 0;
            border-radius: 15px;
            overflow: hidden;
            box-shadow: 0 4px 15px rgba(0,0,0,0.05);
            background: white;
          }
          
          .dh-enhanced-table thead th {
            background: #374151 !important;
            color: white !important;
            font-weight: 700 !important;
            font-size: 0.875rem !important;
            text-transform: uppercase !important;
            padding: 1rem 0.75rem !important;
            border: none !important;
            position: sticky !important;
            top: 0 !important;
            z-index: 10 !important;
          }
          
          .dh-enhanced-table tbody td {
            padding: 0.75rem;
            border: none;
            border-bottom: 1px solid #f3f4f6;
            font-size: 0.9rem;
            vertical-align: middle;
          }
          
          .dh-enhanced-table tbody tr:hover {
            background: linear-gradient(135deg, #f9fafb 0%, rgba(102, 126, 234, 0.02) 100%) !important;
          }
          
          /* Badge moderno */
          .dh-badge {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            border-radius: 10px;
            padding: 8px 12px;
            font-weight: 600;
            font-size: 0.85rem;
          }
        `}
      </style>

      <div className="dh-maintenance-bg">
        <ToastContainer />
        
        <div className="dh-main-header">
          <Container>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h1 className="dh-main-title">
                  <FaUserTie className="me-3" />
                  Mantenimiento Tipos de Origen de Trabajadores
                </h1>
                <p className="dh-main-subtitle">Gestión de tipos de origen (Local, Foráneo, etc.)</p>
              </div>
              <div className="d-flex align-items-center gap-3">
                <Badge className="dh-badge">
                  Proyecto: {selectedProject?.nombre || "No seleccionado"}
                </Badge>
                <Button 
                  className="btn-dh-secondary d-flex align-items-center"
                  onClick={() => navigate("/home")}
                >
                  <FaArrowLeft className="me-2" />
                  Volver
                </Button>
              </div>
            </div>
          </Container>
        </div>

        <Container fluid className="py-4">
          <Row>
            <Col lg={12}>
              <Card className="dh-card">
                <Card.Header className="dh-card-header dh-card-header-primary">
                  <div className="d-flex justify-content-between align-items-center">
                    <h5 className="mb-0">
                      <FaUserTie className="me-2" />
                      Tipos de Origen de Trabajadores
                    </h5>
                    <div className="d-flex gap-2">
                      <Button
                        className="btn-dh-primary d-flex align-items-center"
                        onClick={handleOpenCreateModal}
                      >
                        <FaPlus className="me-2" size={14} />
                        Nuevo Tipo de Origen
                      </Button>
                    </div>
                  </div>
                </Card.Header>
                <Card.Body>
                  <Row className="mb-3">
                    <Col md={6}>
                      <div className="position-relative">
                        <FaSearch className="position-absolute" style={{ left: '15px', top: '12px', color: '#6c757d', zIndex: 10 }} />
                        <Form.Control
                          type="text"
                          placeholder="Buscar por nombre..."
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                          style={{ paddingLeft: '40px' }}
                          className="dh-form-control"
                        />
                      </div>
                    </Col>
                  </Row>

                  {loading ? (
                    <div className="text-center py-5">
                      <Spinner animation="border" variant="primary" />
                      <p className="mt-3">Cargando...</p>
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <Table className="dh-enhanced-table">
                        <thead>
                          <tr>
                            <th>ID</th>
                            <th>Nombre</th>
                            <th>Acciones</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredTipos.length === 0 ? (
                            <tr>
                              <td colSpan="3" className="text-center py-4">
                                {searchTerm ? "No se encontraron resultados" : "No hay tipos de origen registrados"}
                              </td>
                            </tr>
                          ) : (
                            filteredTipos.map((tipo) => (
                              <tr key={tipo.id}>
                                <td>{tipo.id}</td>
                                <td><strong>{tipo.nombre}</strong></td>
                                <td>
                                  <div className="d-flex gap-2">
                                    <Button
                                      className="btn-dh-warning d-flex align-items-center"
                                      size="sm"
                                      onClick={() => handleOpenEditModal(tipo)}
                                    >
                                      <FaEdit className="me-1" size={12} />
                                      Editar
                                    </Button>
                                    <Button
                                      className="btn-dh-danger d-flex align-items-center"
                                      size="sm"
                                      onClick={() => handleDelete(tipo)}
                                    >
                                      <FaTrash className="me-1" size={12} />
                                      Eliminar
                                    </Button>
                                  </div>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </Table>
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>

        {/* Modal para crear/editar */}
        <Modal show={showModal} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>{editTipo ? "Editar Tipo de Origen" : "Nuevo Tipo de Origen"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Nombre *</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.nombre}
                  onChange={(e) => setFormData({ ...formData, nombre: e.target.value })}
                  placeholder="Ej: Local, Foráneo"
                  className="dh-form-control"
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Cancelar
            </Button>
            <Button className="btn-dh-primary" onClick={handleSave}>
              {editTipo ? "Actualizar" : "Crear"}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal de confirmación de eliminación */}
        <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Confirmar Eliminación</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            ¿Está seguro de que desea eliminar el tipo de origen "{tipoToDelete?.nombre}"?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
              Cancelar
            </Button>
            <Button className="btn-dh-danger" onClick={confirmDelete}>
              Eliminar
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default MantenimientoTiposOrigenTrabajadores;
